import React from "react";

import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";

import PreRegistration from "./PreRegistration";
import PreRegistrations from "./PreRegistrations";

const PreRegistrationsRoute = React.memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PreRegistrations />
      </Route>
      <Route path={`${path}/:id`}>
        <PreRegistration />
      </Route>
      <Redirect to={path} />
    </Switch>
  );
});

export default PreRegistrationsRoute;
